const ImageRequirementsText = () => (
  <p className="text-gray-900 leading-8">
    برای هر استوری نیاز به یک فایل طراحی استاندارد است. فایل ارسال‌شده توسط شما
    بعد از بررسی تخصصی منتشر می‌شود.
    <br /> فایل باید در ابعاد ۹ در ۱۶ با یکی از فرمت های png, jpeg بارگذاری شود.
  </p>
);

export default ImageRequirementsText;
